import { useTranslation } from 'react-i18next';
import { CircleHelp } from 'lucide-react';

export const SUPPORT_URL = 'https://t.me/fast_support_admin';

/** Suzuvchi "Yordam" (yechish sahifasida yo'q: editorni to'sib qo'ymasin, u yerda Navbar'dagi havola) */
export function HelpButton() {
  const { t } = useTranslation();
  return (
    <a
      href={SUPPORT_URL}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={t('footer.helpOpen')}
      title={t('footer.help')}
      className="no-print fixed bottom-4 right-4 z-40 flex h-11 w-11 items-center justify-center rounded-full border border-line bg-elevated text-content-secondary shadow-[var(--shadow)] transition-colors hover:text-content"
    >
      <CircleHelp className="h-5 w-5" aria-hidden />
    </a>
  );
}
